import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";
import medallion from "src/ui/assets/badge-medallion.svg";
import iconWeightScale from "src/ui/assets/icon-weight-scale-gradient.svg";

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Badge = styled.div`
  width: 100%;
  position: relative;
  aspect-ratio: 1;
  z-index: 1;

  .badge-medallion {
    width: 100%;
    height: 100%;
    display: block;
    animation: ${rotateAnimation} 10s linear infinite;
  }

  .badge-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: 38%;
    aspect-ratio: 1;
    object-fit: cover;
  }
`;

const CurvedText = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;

  text {
    font-family: "STK Bureau", sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.02em;
    fill: url(#badge-text-gradient);
  }
`;

const BadgeCurvedLabel: FC<{ label: string }> = ({ label }) => (
  <CurvedText viewBox="0 0 184 184">
    <defs>
      <path id="badge-curve" d="M 50,115 A 42,42 0 0 0 134,115" fill="none" />
      <linearGradient
        id="badge-text-gradient"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#0E3763" />
        <stop offset="52.6%" stopColor="#5B4855" />
        <stop offset="100%" stopColor="#8A6947" />
      </linearGradient>
    </defs>
    <text textAnchor="middle">
      <textPath href="#badge-curve" startOffset="50%">
        {label}
      </textPath>
    </text>
  </CurvedText>
);

const CompletedMonthBadge: FC<{ className?: string; weekCount?: number }> = (
  props
) => {
  const label =
    props.weekCount != null ? `${props.weekCount} weeks` : undefined;

  return (
    <Badge className={props.className}>
      <img className="badge-medallion" src={medallion} alt="" />
      <img
        className="badge-icon"
        src={iconWeightScale}
        alt="icon-weight-scale"
      />
      {label && <BadgeCurvedLabel label={label} />}
    </Badge>
  );
};

export default CompletedMonthBadge;
